/* Common Imports */

import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";

/* Component Imports */
import { Button, Checkbox, FormControlLabel, Link, Snackbar, TextField } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MuiIconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import MuiAlert from "@material-ui/lab/Alert";
import AppConfig from "../../AppConfig";
import sendToGoogleSheets from "../../lib/sendToGoogleSheets";
/* Action Imports */

// import { fetchLeads } from "../redux-components/Actions";

/* Redux Imports */

// import { connect } from "react-redux";

/* Data Imports */

const useStyles = makeStyles((theme) => ({
  modal: {
    padding: "1rem",
    width: "100%",
    "& .MuiDialog-paper": {
      borderRadius: "1rem",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },
  heading: {
    color: "#0DB14B",
    fontWeight: "700",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2.25rem",
    },
  },
  textField: {
    margin: "0rem 0rem 1.125rem 0rem",
    width: "100%",
  },
  checkboxRow: {
    padding: "0.5rem 0rem 1.5rem 0.5rem",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.up("lg")]: {
      alignItems: "center",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  grey: {
    fontSize: "0.9rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.85rem",
    },
  },
  link: {
    fontSize: "0.9rem",
    color: "#037DBB",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.85rem",
    },
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100%",
    padding: "2rem 1.5rem 2rem 1.5rem",
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    padding: "1rem",
    margin: "0.5rem 0rem 0.5rem 0rem",
    gap: "1rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
      justifyContent: "center",
    },
  },
  primaryButton: {
    padding: "0.5rem 1rem",
    background: "#0DB14B",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: "500",
    borderRadius: "0.75rem",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
      color: "#FFFFFF",
      textDecoration: "none",
      //   textUnderlineOffset: "3px",
      boxShadow: "none",
    },
    "&:disabled": {
      background: "#ececec",
      color: "##88888a",
      border: "solid 1px #ececec",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "0rem 0rem 0rem 0rem",
    },
  },
  cancelButton: {
    background: "#FFFFFF",
    color: "#0DB14B",
    border: "solid 1px #0DB14B",
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "none",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      margin: "1rem 0rem 0rem 0rem",
    },
    alignItems: "flex-end",
  },
  phoneContainer: {
    display: "flex",
    gap: "0.5rem",
    width: "100%",
    marginBottom: "1.125rem",
  },
  countryCode: {
    minWidth: "120px",
    "& .MuiSelect-select": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "1rem",
    },
  },
  phoneInput: {
    flex: 1,
  },
}));

function Alert(props) {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
    />
  );
}

const ContactFormModal = (props) => {
  const classes = useStyles();

  const [loadingSnackbar, setLoadingSnackbar] = React.useState(false);
  const [successSnackbar, setSuccessSnackbar] = React.useState(false);
  const [errorSnackbar, setErrorSnackbar] = React.useState(false);

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  //   const [message, setMessage] = React.useState("");
  const [atc, setAtc] = React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(true);

  const [countryCode, setCountryCode] = React.useState("+91"); // Default to India

  // Phone validation patterns for different countries
  const phonePatterns = {
    "+91": {
      pattern: /^[6-9]\d{9}$/,
      maxLength: 10,
      errorText: "Please enter a valid Indian mobile number starting with 6, 7, 8, or 9",
    },
    "+65": {
      pattern: /^[689]\d{7}$/,
      maxLength: 8,
      errorText: "Please enter a valid Singapore mobile number starting with 6, 8, or 9",
    },
    "+971": {
      pattern: /^[5]\d{8}$/, // UAE mobile numbers typically start with 5
      maxLength: 9,
      errorText: "Please enter a valid UAE mobile number starting with 5",
    },
    "+1": {
      pattern: /^[2-9]\d{9}$/, // US numbers can't start with 0 or 1
      maxLength: 10,
      errorText: "Please enter a valid US mobile number starting with 2-9",
    },
  };

  // Update the validatePhone function to handle all country-specific validations
  const validatePhone = (phoneNumber) => {
    if (!phoneNumber) return false;

    const validation = phonePatterns[countryCode];
    if (!validation) return false;

    // Check length
    if (phoneNumber.length !== validation.maxLength) return false;

    // Check pattern
    return validation.pattern.test(phoneNumber);
  };

  // Update the getErrorText function to be more descriptive
  const getErrorText = () => {
    if (phone === "") return "";

    const validation = phonePatterns[countryCode];
    if (!validation) return "Invalid country code";

    if (phone.length !== validation.maxLength) {
      return `Please enter exactly ${validation.maxLength} digits`;
    }

    return validation.errorText;
  };
  React.useEffect(() => {
    if (
      name !== (undefined || "") &&
      phone !== (undefined || "") &&
      validatePhone(phone) &&
      email !== (undefined || "") &&
      email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i) &&
      atc === true
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [name, phone, email, atc, countryCode]);

  const submitForm = () => {
    let reqURL =
      AppConfig.apiUrlPrefix +
      "contact?name=" +
      name +
      "&email=" +
      email +
      "&countryCode=" +
      countryCode +
      "&phone=" +
      phone +
      "&atc=" +
      atc +
      "&source=" +
      (props.source ? props.source : "unknown");

    // if (message) {
    //   reqURL += "&message=" + message;
    // }

    reqURL = encodeURI(reqURL);
    console.log(reqURL, "Request URL");

    setBtnDisabled(true);
    setLoadingSnackbar(true);
    fetch(reqURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        res
          .json()
          .then((data) => {
            console.log(data);
            if (data.status === "success") {
              setLoadingSnackbar(false);
              setSuccessSnackbar(true);
              // Keep button disabled after success

              // Send to Google Sheets
              sendToGoogleSheets({
                name: name,
                email: email,
                countryCode: countryCode,
                phone: phone,
                source: props.source || "Contact Form Modal",
                type: "Contact Form Modal",
              })
                .then((result) => {
                  console.log("Google Sheets result:", result);
                })
                .catch((err) => {
                  console.error("Google Sheets error:", err);
                });

              // Add URL parameter for Google Ads tracking when submitted from Eden or Halcyon page
              if (typeof window !== "undefined") {
                if (props.source === "Heavie Eden") {
                  const currentUrl = new URL(window.location.href);
                  currentUrl.searchParams.set("form_submitted", "eden");
                  window.history.pushState({}, "", currentUrl.toString());
                } else if (props.source === "Heavie Halcyon") {
                  const currentUrl = new URL(window.location.href);
                  currentUrl.searchParams.set("form_submitted", "halcyon");
                  window.history.pushState({}, "", currentUrl.toString());
                }
              }
            } else {
              setLoadingSnackbar(false);
              setErrorSnackbar(true);
              setBtnDisabled(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoadingSnackbar(false);
            setErrorSnackbar(true);
            setBtnDisabled(false);
          });
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setErrorSnackbar(true);
        setBtnDisabled(false);
      });
  };
  const handleLoadingSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLoadingSnackbar(false);
  };
  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbar(false);
  };

  return (
    <React.Fragment>
      <Snackbar
        open={loadingSnackbar}
        autoHideDuration={3000}
        onClose={handleLoadingSnackbarClose}
      >
        <Alert
          onClose={handleLoadingSnackbarClose}
          severity="info"
        >
          Sending information...
        </Alert>
      </Snackbar>
      <Snackbar
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={handleSuccessSnackbarClose}
      >
        <Alert
          onClose={handleSuccessSnackbarClose}
          severity="success"
        >
          Thanks, {name}! ! We&apos;ll get in touch shortly.
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={3000}
        onClose={handleErrorSnackbarClose}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
        >
          Oops! Something seems to have gone wrong!
        </Alert>
      </Snackbar>
      {/* <Snackbar
        open={otperrorSnackbar}
        autoHideDuration={3000}
        onClose={handleOtpErrorSnackbarClose}
      >
        <Alert onClose={handleOtpErrorSnackbarClose} severity="error">
          Oops! OTP is invalid please try again !
        </Alert>
      </Snackbar> */}
      <Dialog
        className={classes.modal}
        onClose={() => {
          setName("");
          setPhone("");
          setAtc(false);
          props.onClose();
        }}
        aria-labelledby="brochure-download-modal"
        open={props.open}
        fullWidth={true}
      >
        <DialogTitle
          id="download-modal-title"
          onClose={props.onClose}
        >
          <Typography
            variant="h5"
            component="p"
            className={classes.heading}
            style={{
              color:
                props.source === "Heavie Eden" ? "#693471" : props.source === "Heavie Halcyon" ? "#B56F79" : "#0DB14B",
            }}
          >
            {props.source === "Heavie Eden" ? "Book a Site Visit" : "Contact us"}
          </Typography>
          <MuiIconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={props.onClose}
          >
            <CloseIcon />
          </MuiIconButton>
        </DialogTitle>
        <form
          method="GET"
          id="cf"
        >
          <DialogContent
            dividers
            className={classes.dialogContent}
          >
            <Snackbar
              open={loadingSnackbar}
              autoHideDuration={3000}
              onClose={handleLoadingSnackbarClose}
            >
              <Alert
                onClose={handleLoadingSnackbarClose}
                severity="info"
              >
                Sending information...
              </Alert>
            </Snackbar>
            <Snackbar
              open={successSnackbar}
              autoHideDuration={3000}
              onClose={handleSuccessSnackbarClose}
            >
              <Alert
                onClose={handleSuccessSnackbarClose}
                severity="success"
              >
                Thanks, {name}! We&apos;ll get in touch shortly.
              </Alert>
            </Snackbar>
            <Snackbar
              open={errorSnackbar}
              autoHideDuration={3000}
              onClose={handleErrorSnackbarClose}
            >
              <Alert
                onClose={handleErrorSnackbarClose}
                severity="error"
              >
                Oops! Something has gone wrong! Please try again.
              </Alert>
            </Snackbar>

            <form
              id="cf"
              className={classes.contactForm}
              method="GET"
            >
              {/* <div className={classes.textforms}> */}
              <TextField
                id="name"
                name="name"
                label="Name"
                required={true}
                type="text"
                autoComplete="off"
                className={classes.textField}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^A-Za-z\s.]/g, "");
                  setName(value);
                }}
                value={name}
                variant="outlined"
                inputProps={{
                  maxLength: 50,
                  pattern: "[A-Za-z\\s.]*",
                }}
                InputProps={{
                  style: {
                    borderRadius: "16px",
                  },
                }}
              />
              <label htmlFor="name"></label>
              <div className={classes.phoneContainer}>
                <Select
                  value={countryCode}
                  onChange={(event) => {
                    setCountryCode(event.target.value);
                    setPhone(""); // Clear phone when country changes
                  }}
                  variant="outlined"
                  className={classes.countryCode}
                  style={{
                    borderRadius: "1rem",
                  }}
                >
                  <MenuItem value="+91">🇮🇳 +91</MenuItem>
                  <MenuItem value="+65">🇸🇬 +65</MenuItem>
                  <MenuItem value="+971">🇦🇪 +971</MenuItem>
                  <MenuItem value="+1">🇺🇸 +1</MenuItem>
                </Select>
                <TextField
                  id="phone"
                  name="phone"
                  label="Phone"
                  required={true}
                  autoComplete="off"
                  type="tel"
                  value={phone}
                  className={classes.phoneInput}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, "");
                    if (value.length <= phonePatterns[countryCode].maxLength) {
                      setPhone(value);
                    }
                  }}
                  variant="outlined"
                  error={phone !== "" && !validatePhone(phone)}
                  helperText={phone !== "" && !validatePhone(phone) ? getErrorText() : ""}
                  InputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: {
                      borderRadius: "16px",
                    },
                  }}
                />
              </div>
              {/* </div> */}
              <TextField
                id="email"
                name="email"
                label="Email"
                type="email"
                required={true}
                autoComplete="off"
                className={classes.textField}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                value={email}
                variant="outlined"
                error={email !== "" && !email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)}
                helperText={
                  email !== "" && !email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
                    ? "Please enter a valid email address"
                    : ""
                }
                InputProps={{
                  style: {
                    borderRadius: "16px",
                  },
                }}
              />
              <label htmlFor="email"></label>
              {/* <TextField
            id="message"
            name="message"
            label="Message"
            type="text"
            multiline={true}
            autoComplete="off"
            rows={4}
            className={classes.textField}
            onChange={(event) => {
              setMessage(event.target.value);
            }}
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: "16px",
              },
            }}
          />
          <label htmlFor="message"></label> */}
              <input
                id="source"
                type="hidden"
                name="source"
                value={props.source}
                onChange={(event) => {
                  setSource(event.target.value);
                }}
              />
              <div className={classes.checkboxRow}>
                <FormControlLabel
                  style={{ alignItems: "flex-start" }}
                  control={
                    <Checkbox
                      style={{ padding: "0rem 0.5rem 0rem 0rem" }}
                      checked={atc}
                      onChange={(event) => {
                        setAtc(atc === true ? false : true);
                      }}
                      color="primary"
                      value={atc}
                      name="agree"
                    />
                  }
                  label={
                    <span>
                      <Link
                        href="/terms"
                        target="_blank"
                        aria-label="Terms of Service"
                        title="Terms of Service"
                        rel="noopener"
                        className={classes.grey}
                      >
                        Terms of Service {""}
                      </Link>
                      <span className={classes.grey}>and</span>{" "}
                      <Link
                        href="/privacy"
                        target="_blank"
                        aria-label="Privacy Policy"
                        title="Privacy Policy"
                        rel="noopener"
                        className={classes.grey}
                      >
                        Privacy Policy.
                      </Link>
                    </span>
                  }
                />
              </div>
              <div className={classes.btnRow}>
                <Button
                  variant="outlined"
                  title="Submit"
                  onClick={submitForm}
                  disabled={btnDisabled}
                  rel="noopener"
                  className={classes.primaryButton}
                >
                  Submit
                </Button>
              </div>
            </form>
          </DialogContent>

          {/* <DialogActions
            className={classes.dialogActions}
            disableSpacing
          >
            <Button
              variant="contained"
              label="Close"
              onClick={props.onClose}
              className={classes.cancelButton}
            >
              Close
            </Button>
            <Button
              variant="contained"
              title="Submit"
              onClick={submitForm}
              disabled={btnDisabled}
              rel="noopener"
              className={classes.primaryButton}
            >
              Submit
            </Button>
          </DialogActions> */}
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default ContactFormModal;
